(function () {
  // ========EU=============
  var cachedCountry = localStorage.getItem("userCountryCode");

  var euCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];

  function isEUUser(country) {
    return country && euCountries.includes(country);
  }

  if (!cachedCountry) {
    function getUserLocation() {
      fetch("https://api.ashimarywig.com/api/index/ipaddress", { cache: "force-cache" })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var userCountry = data.data.country;
          localStorage.setItem("userCountryCode", userCountry);

          if (isEUUser(userCountry)) {
            if (localStorage["gtag.consent.option"] !== undefined) {
              var option = JSON.parse(localStorage["gtag.consent.option"]);
              gtag("consent", "update", option);
            }
          }
        })
        .catch(function () {});
    }

    window.addEventListener(
      'load',
      function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(getUserLocation, { timeout: 3000 });
        } else {
          setTimeout(getUserLocation, 1500);
        }
      },
      { once: true }
    );
  } else if (isEUUser(cachedCountry)) {
    if (localStorage["gtag.consent.option"] !== undefined) {
      var option = JSON.parse(localStorage["gtag.consent.option"]);
      gtag("consent", "update", option);
    }
  }
  // ========EU=============
})();
